import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import Modal from '../Modal';


const RedirectModal = ({data, onClose}) => {

  const closeModal = () => {
    onClose();
  }

  const sendLeaveRequest = async function () {
    const url = data.newSearchUrl;
    try {
      const response = await axios.post(url);
      window.location = response.data.successLink;
    } catch (error) {
      console.error(error.toJSON());
    }
  }

  return (
    <Modal
      title=""
      className="text-center"
      closeModalHandler={closeModal}
      closeBtn
    >
      <div className="popin">
        {data.warning && (
          <h3 className="Error__message__title">{data.warning}</h3>
        )}
        {data.warningDescription && data.newSearchText && (
          <p className="Error__message__description">
            {data.warningDescription}
            <span
              role="button"
              className="link"
              tabIndex="0"
              onKeyDown={() => null}
              onClick={sendLeaveRequest}
            >
              {data.newSearchText}
            </span>
          </p>
        )}
        {data.continuePayment && (
          <button
            type="button"
            className="Error__message__button"
            onClick={closeModal}
          >
            {data.continuePayment}
          </button>
        )}
      </div>
    </Modal>
  )
}

RedirectModal.propTypes = {
  data: PropTypes.shape({
    warning: PropTypes.string,
    warningDescription: PropTypes.string,
    newSearchText: PropTypes.string,
    continuePayment: PropTypes.string
  }).isRequired,
  onClose: PropTypes.func.isRequired
}

export default RedirectModal;
